import { client } from 'pioneira-ui';

export default {
  namespaced: true,
  state: {
    usuario: JSON.parse(localStorage.getItem('user')),
  },
  actions: {
    async forceUserTokenValidation() {
      const { data } = await client.get(`/api/force-user-token-validation`);
      return data;
    },
  },
};
